import { SignalProvider } from "../../api/signal-providers";
import { getImageUrl, ImageUrlOptions } from "../../shared/image-utils";
import user from '../../shared/images/user.png';

export function getProfileImage(provider: SignalProvider, options?: ImageUrlOptions) {
  return provider.profile_image ? getImageUrl(provider.profile_image, options) : user;
}